<template>
  <v-card
    flat
    elevation="3"
  >
    <v-card-text>
      <v-row>
        <v-col
          md="4"
          cols="12"
        >
          <v-row class="justify-center">
            <span class="font-weight-semibold text--primary">Alerta de nível</span>
          </v-row>

          <v-row
            v-for="(alerta, index) in slaAlertasLocale"
            :key="index"
          >
            <sla-configuracao-alerta-checkbox
              :niveis-alerta="niveisAlerta"
              :sla-alerta="alerta"
              :get-is-alerta-valido="getIsAlertaValido"
            />
          </v-row>
        </v-col>

        <v-col
          md="4"
          cols="12"
        >
          <v-row class="d-flex justify-center">
            <span class="font-weight-semibold text--primary">Notificar</span>
          </v-row>

          <v-row
            v-for="(alerta, index) in slaAlertasLocale"
            :key="index"
          >
            <v-col
              cols="12"
              class="d-flex justify-center pa-0"
            >
              <v-checkbox
                v-model="alerta.notificarGestor"
                label="Gestor"
                @change="() => $emit('update:sla-alertas', slaAlertasLocale)"
              />

              <v-checkbox
                v-model="alerta.notificarAgente"
                class="ml-2"
                label="Agente"
                @change="() => $emit('update:sla-alertas', slaAlertasLocale)"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col
          md="4"
          cols="12"
        >
          <v-row class="justify-center">
            <span class="font-weight-semibold text--primary">Tipo de notificação</span>
          </v-row>

          <v-row
            v-for="(alerta, index) in slaAlertasLocale"
            :key="index"
          >
            <v-col
              cols="12"
              class="d-flex justify-center pa-0"
            >
              <!-- <v-checkbox
                v-model="alerta.notificarViaBrowser"
                label="Browser"
                @change="() => $emit('update:sla-alertas', slaAlertasLocale)"
              /> -->

              <v-checkbox
                v-model="alerta.notificarViaBadge"
                class="ml-2"
                label="Badge"
                @change="() => $emit('update:sla-alertas', slaAlertasLocale)"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, watchEffect } from '@vue/composition-api'
import SlaConfiguracaoAlertaCheckbox from './SlaConfiguracaoAlertaCheckbox.vue'

export default {
  components: {
    SlaConfiguracaoAlertaCheckbox,
  },

  emits: ['update:sla-alertas'],

  props: {
    slaAlertas: {
      type: Array,
      default: () => ([]),
    },
    niveisAlerta: {
      type: Object,
      required: true,
    },
    getIsAlertaValido: {
      type: Function,
      required: true,
    },
  },

  setup(props) {
    const slaAlertasLocale = ref([])

    watchEffect(() => {
      slaAlertasLocale.value = JSON.parse(JSON.stringify(props.slaAlertas))
    })

    return {
      slaAlertasLocale,
    }
  },
}
</script>
